import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedServicesService } from '../../../global/confirmation/shared/shared-services.service';
import { ConfirmationModel } from '../shared/model';

@Component({
	selector: 'app-confirmation',
	templateUrl: './confirmation.component.html',
	styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: ConfirmationModel,
		private sharedService: SharedServicesService
	) {}

	deleteRowOn() {
		this.sharedService.sendClickEvent();
	}
}
